module.exports = __webpack_public_path__ + "img/kbank.60b4174b.svg";